import {observer} from "mobx-react";
import {useContext, useState} from "react";
import {Button} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {Header} from "../components/sections/Header";
import useInstance from "../hooks/useInstance";
import {AppContext} from "../stores/AppStore";
import {Frame} from "../components/common/Frame";
import {AppRoutes} from "../AppRoutes";
import {LessonsStore} from "../stores/LessonsStore";
import {LessonCard} from "../components/lessons/LessonCard";
import {lessons as lessonsProto} from "../proto/compiled";
import {Pagination} from "../components/system/Pagination";
import {useNavigate} from "react-router";
import {CreateLessonDialog} from "../components/lessons/CreateLessonDialog";

export const Lessons = observer(() => {
  const app = useContext(AppContext)!;
  const store = useInstance(() => new LessonsStore(app), [app]);
  const navigate = useNavigate();
  const [createDialogOpen, setCreateDialogOpen] = useState(false);

  if (!store) return null;

  return <Frame>
    <Header
      pathCrumbs={[
        [AppRoutes.index, 'Home'],
        [undefined, 'Lessons'],
      ]}
      action={app.auth.isLessonEditor ? (
        <Button
          variant="contained"
          startIcon={<AddIcon/>}
          onClick={() => setCreateDialogOpen(true)}
        >
          Create Lesson
        </Button>
      ) : undefined}
    />
    <Frame contentWidth paddingV={2} gap={2}>
      {renderLessonCards(
        store.lessons?.lessons ?? undefined,
        (lesson) => {
          if (!lesson.id) {
            return;
          }
          navigate(AppRoutes.lessonPath(lesson.id));
        }
      )}
      {(store.lessons?.pagination?.nPages ?? 0) > 1 && <Pagination
        pagination={store.lessons!.pagination!}
        onPageChange={(page) => {
          store.lessons!.pagination!.page = page;
          store.load();
        }}
        onPageSizeChange={(pageSize) => {
          store.lessons!.pagination!.pageSize = pageSize;
          store.load();
        }}
        sticky={true}
      />}
    </Frame>

    <CreateLessonDialog
      open={createDialogOpen}
      onClose={() => setCreateDialogOpen(false)}
      onCreated={() => store.load()}
    />
  </Frame>;
});

export const renderLessonCards = (
  items?: lessonsProto.ILesson[],
  onSelect?: (lesson: lessonsProto.ILesson) => void
) => (
  <>
    {items === undefined && <>
      <LessonCard/>
      <LessonCard/>
      <LessonCard/>
      <LessonCard/>
    </>}
    {items !== undefined && items.map(lesson => (
      <LessonCard
        key={lesson.id}
        lesson={lesson}
        onClick={onSelect ? () => onSelect(lesson) : undefined}
      />
    ))}
  </>
);
